import { DriversDataType } from 'QuoteApp/services/endpoints/GetDetails';

export const buildAvailableDrivers = (
  drivers: DriversDataType
): Record<string, string> =>
  Object.values(drivers).reduce<Record<string, string>>(
    (acc, driver) => {
      acc[driver.identifier] = `${driver.firstName.value ?? ''} ${
        driver.lastName.value ?? ''
      }`.trim();
      return acc;
    },
    { unlisted_driver: 'Unlisted Driver' }
  );
